//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  async fetch () {
    // Redirect to the homepage if SGP is disabled
    if (!this.$flags.isActive('website.protect.portal')) return this.$redirect('/')

    await Promise.all([
      this.$store.dispatch('protect/GET_SUBSCRIBER', {
        pk: this.$route.query.pk || this.$store.getters['protect/pk'] || '',
        token: this.$route.query.token || this.$store.getters['protect/token'] || ''
      }),
      this.$store.dispatch('support/GET', 'protect')
    ])

    this.redirectToAuth()
  },
  fetchOnServer: false,
  head () {
    // Start with the default nuxt-i18n tags
    const tags = this.$nuxtI18nSeo()
    
    // Set title
    tags.title = 'SunGod Protect'

    // Add opengraph metadata
    tags.meta = [
      ...tags.meta, {
        hid: 'og:url',
        property: 'og:url',
        content: `https://www.sungod.co${this.$route.path}`
      },
      {
        hid: 'og:title',
        property: 'og:title',
        content: 'SunGod Protect'
      },
      ...this.getDescription('A sustainable approach to fresh lenses for life.')
    ]

    return tags
  },
  computed: {
    loggedIn () {
      return this.$store.getters['protect/token'] !== null
    },
    isAuthRoute () {
      return this.$route.path.includes('/protect/auth')
    }
  },
  watch: {
    loggedIn () {
      this.redirectToAuth()
    }
  },
  methods: {
    redirectToAuth () {
      if (this.isAuthRoute && this.loggedIn) {
        return this.$redirect('/protect')
      } else if (!this.isAuthRoute && !this.loggedIn) {
        return this.$redirect('/protect/auth')
      }
    }
  }
}
